import { Modal, ModalHeader, ModalTitle } from "react-bootstrap";
import { Cancel01Icon } from "../../assets/icons";

const withModal = (Component) => {
    return function ModalWrapper({
        isOpen = false,
        onClose = () => { },
        className = "",
        title = "",
        size = "md",
        centered = true,
        backdrop = true,
        keyboard = true,
        scrollable = false,
        dialogClassName = "",
        contentClassName = "",
        backdropClassName = "",
        ...props
    }) {
        if (!isOpen) return null;

        return (
            <Modal
                show={isOpen}
                onHide={onClose}
                size={size}
                centered={centered}
                backdrop={backdrop}
                keyboard={keyboard}
                scrollable={scrollable}
                className={className}
            >
                <ModalHeader className={title ? "" : "p-0"}>
                    {title && (
                        <ModalTitle>{title}</ModalTitle>
                    )}
                    <button className="close-btn"
                        onClick={onClose}>
                        <Cancel01Icon />
                    </button>
                </ModalHeader>

                <Component {...props} onClose={onClose} />
            </Modal>
        );
    };
};

export default withModal;
